import { Button, Grid, Option, Select, Stack, Table, Typography } from "@mui/joy"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import { rpcPost } from "../../rpc/rpc_helper"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { displayGeneralDetail } from "../../helper/general-details/GeneralDetailSlice"
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { triggerBaixaLog, updateExecucoesAtributo } from "../ScriptManagerSlice"
import ModalLog from "../components/ModalLog"
import { Link as LinkRouter } from "react-router-dom"
import { miliToMascara, tempoAtras} from '../../helper/functions'

function TodasExecPage() {

    var dispatch = useDispatch();
    var servidorUrl = useSelector((state) => state.rpc.servidorUrl)
    var token = useSelector((state) => state.auth.token)
    var legadoExec = useSelector((state) => state.scripts.execucoes)
    var isOpen = legadoExec.modalOpen
    var logData = legadoExec.logData
    var baixandoLog = legadoExec.baixandoLog

    var [execs, setExecs] = useState({
        loading: true,
        lista: [],
        scripts: [],
        dadosGeral: null,
    })

    var [filtros, setFiltros] = useState({
        script: "TODOS",
        estado: "TODOS",
        sucesso: "TODOS"
    })

    const atualizar = async () => {
        await loadDadosGeralExecucao();
        await loadListaExecucao();
    }

    const openLog = (scriptId, execucaoId) => {
        dispatch(triggerBaixaLog({ scriptId, execucaoId }))
    }

    const loadListaScript = async () => {
        setExecs((prev) => ({ ...prev, loading: true, scripts: [] }))

        var r = await rpcPost(servidorUrl, token, null, {
            "action": "SCPS_LISTA_SCRIPTS",
            "runNow": true,
            "payload": JSON.stringify({})
        });

        if (r.status == 200) {
            setExecs((prev) => ({ ...prev, loading: false, scripts: r.data.payload.filter(s => s.dataCancelamento == null) }))
        }
    }

    const loadListaExecucao = async () => {

        setExecs((prev) => ({ ...prev, loading: true, lista: [] }))
        var r = await rpcPost(servidorUrl, token, null, {
            "action": "SCPS_LISTA_ULTIMAS_EXECUCOES",
            "runNow": true,
            "payload": JSON.stringify({
                "qtde": 1000
            })
        });

        if (r.status == 200) {
            setExecs((prev) => ({ ...prev, loading: false, lista: r.data.payload }))
        }
    }

    const loadDadosGeralExecucao = async () => {
        setExecs((prev) => ({ ...prev, loading: true, lista: [] }))
        var r = await rpcPost(servidorUrl, token, null, {
            "action": "GET_DADOS_EXECUCAO_SERVICE_APLICACAO_RPC",
            "runNow": true,
            "payload": JSON.stringify({})
        });

        if (r.status == 200) {
            setExecs((prev) => ({ ...prev, loading: false, dadosGeral: JSON.parse(r.data.payload) }))
        }
    }

    React.useEffect(() => {
        async function fetchData() {
            await loadListaScript()
            await loadDadosGeralExecucao();
            await loadListaExecucao();
        }
        fetchData();
    }, []);

    return <Grid container sx={{ p: 1 }}>
        <ModalLog isOpen={isOpen} close={() => {

            dispatch(updateExecucoesAtributo({
                campo: "modalOpen",
                value: false
            }))

        }} data={logData} baixando={baixandoLog} />
        <Grid xs={12} style={{paddingBottom: 10}}>
            {execs.dadosGeral && <Stack spacing={1} alignItems={"left"}>
                <Typography><b>Runners</b> {execs.dadosGeral.activeRunners}/{execs.dadosGeral.maxRunners}</Typography>
                <Typography><b>LastRunnerStarted:</b> {execs.dadosGeral.lastRunnerStarted} </Typography>
                <Typography><b>DataServidorAgora:</b> {execs.dadosGeral.dataServidor} ({tempoAtras(execs.dadosGeral.lastRunnerStarted, execs.dadosGeral.dataServidor, true)})</Typography>
            </Stack>}
        </Grid>
        <Grid xs={12}>
            <Stack direction="row" spacing={1} alignItems={"center"}>
                <Typography>Ir para: </Typography>
                <Link to="/scripts/lista">
                    <Button color="primary">Lista de Scripts</Button>
                </Link>
                <Link to="/scripts/agendamentos">
                    <Button color="primary">Agendamentos</Button>
                </Link>
                <Button onClick={() => atualizar()} color="danger">Atualizar</Button>
            </Stack>
        </Grid>
        <Grid xs={12} sx={{ pt: 1 }}>
            <Stack direction="row" spacing={1} alignItems={"center"}>
                <Typography>Filtros</Typography>
                <Select value={filtros.script} onChange={
                    (a, v) => {
                        setFiltros((prev) => ({ ...prev, script: v }))
                    }
                } placeholder="Scripts" label="Scripts">
                    <Option value="TODOS">Todos</Option>
                    {execs.scripts.map(s => {
                        return <Option key={s.id} value={s.id}>{s.nome}</Option>
                    })}
                </Select>
                <Typography>Estados</Typography>
                <Select value={filtros.estado} onChange={
                    (a, v) => {
                        setFiltros((prev) => ({ ...prev, estado: v }))
                    }
                } placeholder="Scripts" label="Scripts">
                    <Option value="TODOS">Todos</Option>
                    {["Aguardando", "Executando", "Concluído", "Cancelado"].map(s => {
                        return <Option key={s} value={s}>{s}</Option>
                    })}
                </Select>

                <Typography>Sucesso</Typography>
                <Select value={filtros.sucesso} onChange={
                    (a, v) => {
                        setFiltros((prev) => ({ ...prev, sucesso: v }))
                    }
                } placeholder="Scripts" label="Scripts">
                    <Option value="TODOS">Todos</Option>
                    {["SUCESSO", "FRACASSO"].map(s => {
                        return <Option key={s} value={s}>{s}</Option>
                    })}
                </Select>
            </Stack>
        </Grid>
        <Grid xs={12} sx={{ pt: 1 }}>
            {execs.loading && <Typography>Loading...</Typography>}
            {!execs.loading && <Table size="small" aria-label="striped table" stripe={"odd"}>
                <thead>
                    <tr>
                        <th style={{ width: "4%", textAlign: "left" }}>ID</th>
                        <th style={{ width: "13%", textAlign: "left" }}>Data</th>
                        <th style={{ width: "9%", textAlign: "left" }}>Status</th>
                        <th style={{ width: "8%", textAlign: "left" }}>Temp</th>
                        <th style={{ width: "8%", textAlign: "left" }}>Started</th>
                        <th style={{ width: "3%", textAlign: "left" }}>Suc.</th>
                        <th style={{ textAlign: "left" }}>Nome</th>
                        <th style={{ width: "5%", textAlign: "left" }}>Go</th>
                        <th style={{ width: "7%", textAlign: "left" }}>Nota</th>
                        <th style={{ width: "6%", textAlign: "left" }}>Params</th>
                        <th style={{ width: "5%", textAlign: "left" }}>LOG</th>
                    </tr>
                </thead>
                <tbody>
                    {execs.lista
                        .filter(e => {

                            var scriptDeveIr = filtros.script == "TODOS"
                            if (filtros.script != "TODOS") {
                                console.log("Nao é todos")
                                scriptDeveIr = e.scriptId == filtros.script
                            }

                            var estadoDeveIr = filtros.estado == "TODOS"
                            if (filtros.estado != "TODOS") {
                                estadoDeveIr = filtros.estado.toUpperCase() == e.status.toUpperCase()
                            }

                            var sucessoDeveIr = filtros.sucesso == "TODOS"
                            if (filtros.sucesso != "TODOS") {
                                sucessoDeveIr = filtros.sucesso == "SUCESSO"
                                    ? e.sucesso == true :
                                    e.sucesso == false
                            }

                            return scriptDeveIr && estadoDeveIr && sucessoDeveIr
                        })
                        .map(e => {

                            return <tr className="nova_linha" key={e.execucaoId}>
                                <td>
                                    <Link onClick={() => dispatch(displayGeneralDetail(e.execucaoId))
                                    }>{"ID"}</Link>
                                </td>
                                <td>
                                    {e.dataSolicitacaoBR.replace("2024", "24")}
                                </td>
                                <td>
                                    {e.status}
                                </td>
                                <td>
                                    {miliToMascara(e.tempoExecucao)}
                                </td>
                                <td>
                                    {tempoAtras(e.dataInicioExecucaoUS, e.dataAgoraServidorUS)}
                                </td>
                                <td>
                                    {e.sucesso ?
                                        <CheckCircleOutlineIcon style={{ color: "green" }} /> :
                                        <ErrorOutlineIcon style={{ color: "red" }} />}
                                </td>
                                <td>
                                    <Link onClick={() => dispatch(displayGeneralDetail(e.nome))
                                    }>{e.nome.length > 40 ? e.nome.slice(0, 40) + "..." : e.nome}</Link>

                                </td>
                                <td>
                                    <LinkRouter to={"/scripts/" + e.scriptId}>
                                        [GO]
                                    </LinkRouter>

                                </td>
                                <td>
                                    {e.nota.length > 0 ?
                                        <Link onClick={() => dispatch(displayGeneralDetail(e.nota))
                                        }>{"Nota"}</Link> :
                                        "-"}
                                </td>
                                <td>
                                    {e.params != null && e.params.length > 0 ?
                                        <Link onClick={() => dispatch(displayGeneralDetail(e.params))
                                        }>{"Params"}</Link> :
                                        "-"}
                                </td>
                                <td>
                                    <Link onClick={() => openLog(e.scriptId, e.execucaoId)}>LOG</Link>
                                </td>
                            </tr>
                        })}
                </tbody>
            </Table>}
        </Grid>
    </Grid>
}



export default TodasExecPage